import { create } from 'zustand';

type Flags = { drawer: boolean; palette: boolean; help: boolean; stores: boolean; language: boolean };
export const useUi = create<Flags & { set(p: Partial<Flags>): void }>((set) => ({
  drawer: false,
  palette: false,
  help: false,
  stores: false,
  language: false,
  set: (p) => set(p),
}));
